import { Component, Input, OnInit } from '@angular/core';
import { WidgetComponent } from '@widgets/widgets';
import { CreditMyPlan, SeatMyPlan } from '@widgets/models/MyPlan';

@Component({
  selector: 'lms-my-plan',
  templateUrl: './my-plan.component.html',
  styleUrls: ['./my-plan.component.scss']
})
export class MyPlanComponent implements WidgetComponent, OnInit {
  @Input() public data: any;
  public mySeatPlan: SeatMyPlan = {};
  public myCreditPlan: CreditMyPlan = {};
  public planType: string;
  public timezone: string;
  public percentage: number = 0;

  constructor() {}

  public ngOnInit(): void {
    // this.timezone = this.data.managedAccounts.length === 1 && this.data.managedAccounts[0].timezone;
    this.timezone = this.data.user.timezone;
    this.mySeatPlan = this.data['type'] === 'seats' ? this.data['myPlan'] : {};
    this.myCreditPlan = this.data['type'] === 'credits' ? this.data['myPlan'] : {};
    this.planType = this.data['type'];
  }

  public getPercentage(value) {
    if (this.mySeatPlan['totalSeats']) {
      this.percentage = (value * 100) / this.mySeatPlan['totalSeats'];
    }
    if (this.myCreditPlan['totalCredits']) {
      this.percentage = (value * 100) / this.myCreditPlan['totalCredits'];
    }
    return Math.round(this.percentage);
  }
}
